/**
 * description: 个人素材库——预览窗口
 * created by he.zhikai
 * created on 2017.06.26
 */
'use strict';
angular.module('resourceCenterMaterialModule').controller('personalMaterialFilePreviewCtrl', [
    '$scope',
    '$element',
    '$q',
    '$timeout',
    '$modalInstance',
    '$window',
    'modalDialog',
    'trsHttpService',
    'item',
    '$sce',
    'trsUploadAVNewService',
    'editCenUploadVideoForXjService',
    function(
        $scope,
        $element,
        $q,
        $timeout,
        $modalInstance,
        $window,
        modalDialog,
        trsHttpService,
        item,
        $sce,
        trsUploadAVNewService,
        editCenUploadVideoForXjService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data = {
                fileId: angular.copy(item.relationid), // 稿件id
                fileType: item.relationtype === 0 ? '0' : '1' , // 稿件类型
                item: '', // 稿件详情
                video: {}, // 视频信息
            };
            $scope.status = {
                audioVideoidsArray: [], // 播放音视频临时数组
                fullScreen: false,
                page: 1, // 文章预览页码
                loadSuccess: false,
            };
            $scope.params = {
                serviceid: 'mlf_releaseSource',
                methodname: 'getPersonalMaterialInfo',
                PersonalMaterialId: $scope.data.fileId,
            };
            $scope.minSize = false;
            $scope.contentHtml = '';
            $scope.per = 100;
            $scope.parentCss = '';
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            if ($scope.data.fileType == '1') {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'get').then(function(data) {
                    $scope.data.item = data;
                    getFontCssArray();
                    calcuPageNum();
                });
            } else if ($scope.data.fileType == '2') {
                $scope.data.item = item;
            } else if ($scope.data.fileType == '3' || $scope.data.fileType == '5') {
                $scope.data.item = item;
                getVideoInfo();
                // $scope.status.audioVideoidsArray.push(item);
            } else if ($scope.data.fileType == '4') {
                $scope.data.item = item;
                getFontCssArray();
                calcuPageNum();
            }
        }

        /**
         * [getVideoInfo description]获得视频详情
         * @return {[type]} [description]
         */
        function getVideoInfo() {
            editCenUploadVideoForXjService.getVideoMark($scope.data.item.VIDEOID).then(function(data) {
                $scope.data.video = data;
                // $scope.list.VIDEOREL[0].URL = data.videoUrl; //回填URL
                // $scope.list.VIDEOREL[0].ThumbImg = data.ThumbImg;
            });
        }

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [fullScreen description] 弹窗全屏
         * @return {[type]} [description]
         */
        $scope.fullScreen = function() {
            $scope.status.fullScreen = true;
            $('.modal-dialog').addClass('fullScreen');
            calcuPageNum();
        };

        /**
         * [recover description] 恢复弹窗
         * @return {[type]} [description]
         */
        $scope.recover = function() {
            $scope.status.fullScreen = false;
            $('.modal-dialog').removeClass('fullScreen');
            calcuPageNum();
        };

        /**
         * [getFontCssArray description] 初始化获取文字的相关css属性
         * @return {[type]} [description]
         */
        function getFontCssArray() {
            $timeout(function() {
                $scope.contentHtml = $('.filePreview_text_content');
                $scope.parentCss = {
                    fontSize: Number($scope.contentHtml.css('fontSize').replace(/px/, '')),
                    'line-height': Number($scope.contentHtml.css('line-height').replace(/px/, '')),
                };
                $scope.fontCssArray = [];
                $scope.contentHtml.find('*').each(function() {
                    var theFontSize = Number(
                        $(this)
                            .css('fontSize')
                            .replace(/px/, '')
                    );
                    var theLineHeight = Number(
                        $(this)
                            .css('line-height')
                            .replace(/px/, '')
                    );
                    $scope.fontCssArray.push({
                        fontSize: theFontSize,
                        'line-height': theLineHeight,
                    });
                });
            }, 2000);
        }

        /**
         * [addSize description] 处理增大量
         * @param {[type]} step [description]
         */
        $scope.addSize = function(step) {
            if ($scope.minSize && parseInt(step) < 0) {
            } else {
                $scope.per = $scope.per + parseInt(step);
            }
            adjustSize($scope.per);
        };

        /**
         * [adjustSize description] 调节字体大小
         * @return {[type]} [description]
         */
        function adjustSize(per) {
            var fontSize = $scope.parentCss.fontSize * (per / 100);
            if (fontSize < 12) {
                $scope.minSize = true;
                modalDialog.alertType('当前为最小字体', '', 'warning', false);
                return;
            }
            $scope.minSize = false;
            var lineHeight = $scope.parentCss['line-height'] * (per / 100);
            var cssArray = [];
            if ($scope.fontCssArray) {
                for (var i = 0; i < $scope.fontCssArray.length; i++) {
                    var perFont = $scope.fontCssArray[i];
                    cssArray.push({
                        fontSize: perFont.fontSize * (per / 100),
                        'line-height': perFont['line-height'] * (per / 100) + 'px',
                    });
                }
            }
            $scope.contentHtml.css({ fontSize: fontSize, 'line-height': lineHeight + 'px' });
            $scope.contentHtml.find('*').each(function(index) {
                $(this).css(cssArray[index]);
            });
            calcuPageNum();
        }

        /**
         * [calcuPageNum description] 计算文章页码
         * @return {[type]} [description]
         */
        function calcuPageNum() {
            $timeout(function() {
                var pageLimitHeight = 460;
                setTimeout(function() {
                    $scope.status.pageNum = Math.ceil($('.textContent')[0].scrollHeight / pageLimitHeight);
                }, 200);
                if ($scope.status.fullScreen) {
                    pageLimitHeight = $(window).height() - ($('.publicModal .header').outerHeight(true) + $('.body .control').outerHeight(true));
                }
                var lineNum = parseInt(pageLimitHeight / parseInt($('.textContent').css('lineHeight')));
                $scope.onePageHeight = lineNum * parseInt($('.textContent').css('lineHeight')); // 一页的的高度
                $('.filePreview_text_content').height($scope.onePageHeight);
                $('.filePreview_text_content').scroll(function() {
                    var myEfficientFn = debounce(function() {
                        $timeout(function() {
                            var scrollTop = $('.filePreview_text_content').scrollTop();
                            $scope.status.page = Math.ceil((scrollTop + $scope.onePageHeight) / $scope.onePageHeight);
                        });
                    }, 1000);
                    myEfficientFn();
                    // 防抖动
                    function debounce(func, wait, immediate) {
                        var timeout;
                        return function() {
                            var context = this,
                                args = arguments;
                            var later = function() {
                                timeout = null;
                                if (!immediate) {
                                    func.apply(context, args);
                                }
                            };
                            var callNow = immediate && !timeout;
                            clearTimeout(timeout);
                            timeout = setTimeout(later, wait);
                            if (callNow) {
                                func.apply(context, args);
                            }
                        };
                    }
                });
            });
        }

        /**
         * [pageTo description] 左右翻页
         * @param  {[type]} step [description]
         * @return {[type]}      [description]
         */
        $scope.pageTo = function(step) {
            if ($scope.status.page + step > 0 && $scope.status.page + step <= $scope.status.pageNum) {
                $scope.status.page = $scope.status.page + step;
                // $(".textContent").css("top", parseInt($(".textContent").css("top")) - $scope.onePageHeight * step + "px");
                $('.filePreview_text_content').scrollTop(($scope.status.page - 1) * $scope.onePageHeight);
            }
        };

        /**
         * [jumpPage description] 跳转到指定页码
         * @return {[type]} [description]
         */
        $scope.jumpPage = function(ev) {
            if (angular.isDefined(ev) && ev.keyCode == 13) {
                $scope.status.page = parseInt(($scope.status.page + '').replace(/\D/g, ''));
                $scope.status.page = !$scope.status.page ? 1 : $scope.status.page;
                $scope.status.page = $scope.status.page > $scope.status.pageNum ? $scope.status.pageNum : $scope.status.page;
                $scope.status.page = $scope.status.page < 0 ? 1 : $scope.status.page;
                // $(".textContent").css("top", -$scope.onePageHeight * ($scope.status.page - 1) + "px");
                $('.filePreview_text_content').scrollTop(($scope.status.page - 1) * $scope.onePageHeight);
            }
        };
    },
]);
